import { MobileNavApiResponeModel } from "./Models/mobileNaviApiResponse";

export class MobileNavBuilder {
    /**
     * Baut die mobile Navigation anhand der Api Response auf
     * @param response 
     */
    buildMobileNavi(response: MobileNavApiResponeModel) {
        $("ul.mobMenu.mobileNavigation").empty();
        if (response.showBack) {
            var backLink = $("#mobNavProtoTypes").find(".backLink").clone();
            var parentNode = $("#mobNavProtoTypes").find(".parentNode").clone().html(response.name);

            backLink.attr("data-id", response.backId + "");
            backLink.attr("data-weitere", response.parentWeitere + "");
            backLink.attr("data-fachbereich", response.parentFachbereichDetail + "");

            $("ul.mobMenu.mobileNavigation").append(backLink);
            $("ul.mobMenu.mobileNavigation").append(parentNode);
        }
        response.mobileNavItems.forEach(navItem => {
            var navItemProtoType = $("#mobNavProtoTypes").find(".mobNavListItem").clone();

            navItemProtoType.find(".txt").html(navItem.name);
            if (!navItem.hasChildren) {
                navItemProtoType.find("i").remove();
                navItemProtoType.find("a").attr("href", navItem.link);
            }

            if (navItem.id) {
                navItemProtoType.find("a").attr("data-id", navItem.id);
            }

            navItemProtoType.find("a").attr("data-fachbereich", navItem.fachbereichDetail + "");
            navItemProtoType.find("a").attr("data-weitere", navItem.weitereFachgebiete + "");
            if (navItem.weitereFachgebiete) {
                navItemProtoType.find("a").attr("data-id", "-1");
            }

            $("ul.mobMenu.mobileNavigation").append(navItemProtoType);
        });
    }
}